import { StatusChipVariant } from '@occc-app/design-system';
import { Audience_Status } from '@occc/graphql';

const getAudienceStatusVariant = (status?: string): StatusChipVariant => {
  const variantMap: Record<Audience_Status, StatusChipVariant> = {
    [Audience_Status.Active]: 'success',
    [Audience_Status.Archived]: 'error',
    [Audience_Status.Draft]: 'default',
  };

  return status ? (variantMap as any)[status] : 'default';
};

export default getAudienceStatusVariant;
